import { render } from "./InfiniteLoadingList.vue?vue&type=template&id=08fad072&scoped=true"
import script from "./InfiniteLoadingList.vue?vue&type=script&lang=js"
export * from "./InfiniteLoadingList.vue?vue&type=script&lang=js"

import "./InfiniteLoadingList.vue?vue&type=style&index=0&id=08fad072&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08fad072"]])

export default __exports__